<template>
  <div class="contact_us" v-show="type == 1">
    <div class="title_info">
      <p class="title_label">联系我们</p>
    </div>
    <p class="msg">留下您的联系方式，即可获得专属顾问</p>
    <div class="btn" @click="showDialog">预约咨询</div>
  </div>

  <div class="contact_us contact_us2" v-show="type == 2 || type == 3">
    <img src="@/assets/image/weCode.svg" v-show="type == 2" />
    <img src="@/assets/image/weCode2.png" v-show="type == 3" />
    <div class="msgBox">
      <p class="msg1">联系我们</p>
      <p class="msg2">扫描左侧二维码，即可获得专属顾问</p>
    </div>
  </div>
</template>
<script>
import EventBus from "@/api/eventbus.js";
export default {
  props: {
    type: {
      type: String,
      default: "1",
    },
  },
  data() {
    return {};
  },
  methods: {
    showDialog() {
      EventBus.emit("showSubmitDialog");
    },
  },
  mounted() {},
};
</script>
<style scoped lang="less">
.contact_us {
  width: 100%;
  height: 246px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  background-image: url("../assets/image/aboutUsBgc.png");
  background-size: 100% 100%;
  .title_info {
    .title_label {
      color: #333;
      text-align: center;
      font-family: "PingFang SC";
      font-size: 32px;
      font-style: normal;
      font-weight: 600;
      line-height: 160%;
      letter-spacing: 1.28px;
    }
  }
  .msg {
    margin-top: 16px;
    color: #8c9196;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 160%;
    letter-spacing: 0.56px;
  }
  .btn {
    margin-top: 50px;
    width: 160px;
    height: 40px;
    border-radius: 32px;
    background: #d63c40;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    text-align: center;
    font-family: "PingFang SC";
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 160%;
    letter-spacing: 0.56px;
    text-transform: uppercase;
    cursor: pointer;
    &:hover {
      background: #e6373c;
    }
  }
}

.contact_us2 {
  display: flex;
  align-items: center;
  flex-direction: row;
  img {
    width: 108px;
    height: 108px;
    margin-right: 40px;
  }
  .msgBox {
    .msg1 {
      color: #333;
      font-family: "PingFang SC";
      font-size: 24px;
      font-style: normal;
      font-weight: 500;
      line-height: 128%; /* 30.72px */
    }
    .msg2 {
      color: #8c9196;
      font-family: "PingFang SC";
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 160%; /* 22.4px */
      letter-spacing: 0.56px;
      margin-top: 16px;
    }
  }
}
</style>
<style lang="less"></style>
